import { createApp } from 'vue';
import App from './Newsletter.vue';

document.querySelectorAll('[data-newsletter]').forEach((el) => {
    const app = createApp(App);
    app.config.globalProperties.$config = JSON.parse(el.dataset.newsletter);
    app.mount(el);
});
